import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonFooterComponent, footerMenueItems } from '@flitpay-internal/web-footer';
import { environment } from '../environments/environment';
import { routeConstant } from '@flitpay-internal/resources';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs';
import { CommonHeadersComponent } from '@flitpay-internal/web-header';

@Component({
	selector: 'fpb-root',
	standalone: true,
	imports: [RouterOutlet, CommonFooterComponent, CommonHeadersComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent {
	public baseUrl: string = environment?.baseUrl ?? '';

	title = 'flitpay-blogs';
	public exchangeRoute: string = routeConstant?.spotPageRoute ?? '';
	public qbsRoute: string = (routeConstant?.qbsBuyRoute ?? '') + 'btc/inr';
	public siteInternalUrl: string = environment?.seoBaseUrl ?? '';

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		@Inject(PLATFORM_ID) private platformId: Object,
		@Inject(DOCUMENT) private document: Document,
	) {
		if (isPlatformBrowser(this.platformId)) {
			this.scrollToTopOnSlugRoute();
		}
	}
	// footerRoutesMenue
	footerMenues: footerMenueItems[] = [
		{
			id: 1,
			subTitle: 'Company',
			routeItems: [
				{
					id: 1,
					title: 'About Us',
					anchorTitle: "About Us",
					route: '/about-us',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 2,
					title: 'Fees',
					anchorTitle: "Fees",
					route: '/fees',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 3,
					title: 'Careers',
					anchorTitle: "Careers",
					route: '/careers',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 4,
					title: "Flitpay FAQ's",
					anchorTitle: "Flitpay FAQ's",
					route: '/faq',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 5,
					title: 'Privacy Policy',
					anchorTitle: "Privacy Policy",
					route: '/privacy-policy',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 6,
					title: 'Terms of Service',
					anchorTitle: "Terms of Service",
					route: '/terms',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 7,
					title: 'AML and CFT Policy',
					anchorTitle: "AML and CFT Policy",
					route: '/aml-cft-policy',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 8,
					title: 'PMLA and KYC T&C',
					anchorTitle: "PMLA and KYC Policy",
					route: '/pmla-and-kyc-policy',
					isExternal: true,
					target: '_self',
					rel: null
				}
			]
		},
		{
			id: 2,
			subTitle: 'Resources',
			routeItems: [
				{
					id: 1,
					title: 'Blog',
					anchorTitle: "Blog",
					route: '/blog',
					isExternal: false,
					target: '_self',
					rel: null
				},
				{
					id: 2,
					title: 'Flitpay API',
					anchorTitle: "Flitpay API",
					route: 'https://api.flitpay.com/public-api-of-flitpay/#tag/flitpay-public-api',
					isExternal: true,
					target: '_blank',
					rel: 'noopener noreferrer'
				},
				{
					id: 3,
					title: 'Contact Us',
					anchorTitle: "Contact Us",
					route: '/contact-us',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 4,
					title: "Referral",
					anchorTitle: "Referral",
					route: '/referral',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 5,
					title: 'Support',
					anchorTitle: "Support",
					route: 'https://support.flitpay.com/',
					isExternal: true,
					target: '_blank',
					rel: 'noopener noreferrer'
				},
				{
					id: 6,
					title: 'Feature Request',
					anchorTitle: "Request a Feature",
					route: 'https://feedback.flitpay.com/feature-requests',
					isExternal: true,
					target: '_blank',
					rel: 'noopener noreferrer'
				},
				{
					id: 7,
					title: 'Feedback',
					anchorTitle: "Give us Feedback",
					route: 'https://feedback.flitpay.com/',
					isExternal: true,
					target: '_blank',
					rel: 'noopener noreferrer'
				}
			]
		},
		{
			id: 2,
			subTitle: 'Features',
			routeItems: [
				{
					id: 1,
					title: 'Markets',
					anchorTitle: "Markets",
					route: this.siteInternalUrl + '/markets',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 2,
					title: 'Exchange',
					anchorTitle: "Exchange",
					route: this.exchangeRoute,
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 3,
					title: 'Quick Buy Sell',
					anchorTitle: "Quick Buy Sell",
					route: this.qbsRoute,
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 4,
					title: "Earn",
					anchorTitle: "Earn",
					route: '/earn',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 5,
					title: 'Gift Card',
					anchorTitle: "Gift Card",
					route: '/gift-card',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 6,
					title: 'Rewards',
					anchorTitle: "Rewards",
					route: '/reward',
					isExternal: true,
					target: '_self',
					rel: null
				},
				{
					id: 7,
					title: 'Crypto Cashback - Saveora',
					anchorTitle: "Saveora",
					route: 'https://saveora.com/?utm_source=website&utm_medium=footer&utm_id=flitpay',
					isExternal: true,
					target: '_blank',
					rel: 'noopener noreferrer'
				}
			]
		}
	]

	private scrollToTopOnSlugRoute() {
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe(() => {
				const currentRoute = this.getChildRoute(this.route);
				const routeConfig = currentRoute.routeConfig;

				// Check if route path is exactly ':slug'
				if (routeConfig && routeConfig.path === ':slug') {
					window.scrollTo({ top: 0, behavior: 'smooth' });
				}
			});
	}

	// Helper to get deepest child route (where ':slug' would be)
	private getChildRoute(route: ActivatedRoute): ActivatedRoute {
		while (route?.['firstChild']) {
			route = route?.['firstChild'] ?? '';
		}
		return route;
	}
}
